import {omit} from 'external/lodash'
import {createElement} from 'external/react'

import {routes} from 'utils/routing'
import useNavigate from 'hooks/navigate'

import Assessment from 'context/assessment-context'
import Homework from 'context/homework-context'
import Catalog from  'context/catalog-context'
import Openfire from  'context/openfire-context'
import Profile from  'context/profile-context'
import Session from  'context/session-context'
import Settings from  'context/settings-context'
import Student from  'context/student-context'
import Translations from  'context/translations-context'

const contextProviders = [
   Translations.Provider
  ,Settings.Provider
  ,Profile.Provider
  ,Session.Provider
  ,Openfire.Provider
  ,Catalog.Provider
  ,Student.Provider
  ,Assessment.Provider
  ,Homework.Provider
].reverse()

const composeProviders = props => (Previous, Next) => (<Next props={props} children={Previous} />)


export default function withFullContext (Dep) {
  return props => {
    const routingProps = useNavigate(routes)
    return contextProviders.reduce(composeProviders({...props, ...routingProps}), createElement(Dep, {}, props.children))
  }
}

